/* js-cart-notification FIXED */

var CartNotification = {
  init: function () {
    // Guard at window level: survives even if this file is executed more than
    // once (e.g. duplicate <script> or section re-render by BSS B2B), because a
    // re-execution would redefine `var CartNotification` and reset any flag
    // stored on the object itself.
    if (window.__cartNotificationInitialized) return;
    window.__cartNotificationInitialized = true;
    CartNotification._initialized = true;

    const root = window.Shopify?.routes?.root || '/';
    const strings = window.themeStrings || {};
    const stockUnavailableMsg =
      strings.stockUnavailable || 'There is not enough stock available.';
    const addToCartErrorMsg =
      strings.addToCartError || 'Error adding the product.';

    /* -------------------------
       OPEN / CLOSE CART
    ------------------------- */

    $(document).on('click', 'a[href="#open-cart"]', function (e) {
      e.preventDefault();
      history.pushState(null, null, ' ');
      openCart();
    });

    $(document).on('click', '.button-close-cart', closeCart);

    $(document).on('click', function (e) {
      if (!$(e.target).closest('.button-add-cart, .cart-notification, a[href="#open-cart"]').length) {
        closeCart();
      }
    });

    function openCart() {
      $('.cart-notification').addClass('cart-notification-active');
      $('body').addClass('cart-notification-open');
    }

    function closeCart() {
      $('.cart-notification').removeClass('cart-notification-active');
      $('body').removeClass('cart-notification-open');
    }

    /* -------------------------
       ADD TO CART
    ------------------------- */

    $(document).on('click', '.button-add-cart', function () {
      const $btn = $(this);

      // 🚨 IMPORTANT: bloqueig correcte
      if ($btn.hasClass('product-unavailable') || $btn.prop('disabled')) {
        return;
      }

      const productID = Number($btn.attr('data-id'));
      const productParent = $btn.data('parent');
      const randomID = Math.floor(Math.random() * 1e9);
      const $form = $btn.closest('.add-cart-wrapper');
      const $qtyInput = $form.find('input[name="quantity"]').first();

      let productQty = Math.max(1, parseInt($qtyInput.val(), 10) || 1);

      const maxQty = parseInt($qtyInput.attr('max'), 10);
      if (!isNaN(maxQty) && productQty > maxQty) {
        alert(stockUnavailableMsg);
        $qtyInput.val(Math.max(1, maxQty));
        return;
      }

      // 🚨 Validació crítica
      if (!productID || isNaN(productID)) {
        console.error('❌ Variant ID invàlid:', $btn.attr('data-id'));
        return;
      }

      $btn.addClass('product-adding');

      const items = [];

      /* --- ADDONS --- */
      $form.find('[name="product_addon"]').each(function () {
        const $addon = $(this);

        const qty = parseInt($addon.find('[name="quantity"]').val(), 10) || 0;
        if (qty <= 0) return;

        const propName = $addon.find('[name="property"]').data('name');
        const propValue = $addon.find('[name="property"]').data('value');

        const properties = { _link: randomID };

        if (propName) properties[propName] = propValue;

        items.push({
          id: Number($addon.data('id')),
          quantity: qty,
          properties
        });
      });

      /* --- PROPERTIES PRODUCTE PRINCIPAL --- */
      const properties = { _parent: productParent };

      $form.find('[name="product_property"]').each(function () {
        const propName = $(this).data('name');
        const propValue = $(this).data('value');

        if (propName) properties[propName] = propValue;
      });

      if (items.length) {
        properties._mlink = randomID;
      }

      /* --- PRODUCTE PRINCIPAL --- */
      items.push({
        id: productID,
        quantity: productQty,
        properties
      });

      addToCart(
        {
          items,
          sections: ['section-cart-notification']
        },
        $btn
      );
    });

    /* -------------------------
       AJAX ADD TO CART
    ------------------------- */

    function addToCart(payload, $btn) {
      const body = {
        items: payload.items || [],
        sections: Array.isArray(payload.sections)
          ? payload.sections
          : ['section-cart-notification'],
        sections_url: window.location.pathname
      };

      $.ajax({
        url: root + 'cart/add.js',
        method: 'POST',
        data: JSON.stringify(body),
        contentType: 'application/json; charset=utf-8',
        dataType: 'json'
      })
        .done(function (data) {
          updateCartNotificationHTML(data);
          openCart();
        })
        .fail(function (xhr) {
          const msg =
            xhr?.responseJSON?.description ||
            xhr?.responseJSON?.message ||
            addToCartErrorMsg;

          alert(msg);

          console.error('ADD TO CART ERROR:', {
            status: xhr.status,
            response: xhr.responseJSON || xhr.responseText
          });
        })
        .always(function () {
          if ($btn) $btn.removeClass('product-adding');
        });
    }

    CartNotification.addToCart = addToCart;

    /* -------------------------
       UPDATE CART HTML
    ------------------------- */

    function updateCartNotificationHTML(data) {
      const html = data?.sections?.['section-cart-notification'];

      if (!html) {
        console.warn('⚠️ No sections returned', data);
        openCart();
        updateCartTotals();
        return;
      }

      const $cartEl = $('.cart-notification__products');

      $cartEl.empty().append($(html).html());

      bindCartEvents();
      updateCartTotals();
    }

    /* -------------------------
       REMOVE ITEM
    ------------------------- */

    function removeFromCart($item) {
      if ($item.attr('data-line') === 'removed') return;

      const changes = [{ line: $item.attr('data-line'), quantity: 0 }];
      $item.attr('data-line', 'removed');

      const mlink = $item.data('mlink');

      if (mlink) {
        $('.cart-notification-item').each(function () {
          const $linked = $(this);

          if ($linked.data('link') == mlink && $linked.attr('data-line') !== 'removed') {
            changes.push({
              line: $linked.attr('data-line'),
              quantity: 0
            });

            $linked.attr('data-line', 'removed');
          }
        });
      }

      const doChanges = (list) => {
        if (!list.length) {
          afterRemove();
          return;
        }

        $.post(root + 'cart/change.js', list[0], null, 'json')
          .always(() => doChanges(list.slice(1)));
      };

      doChanges(changes);
    }

    function afterRemove() {
      $('.cart-notification-item[data-line="removed"]').fadeOut(200, function () {
        $(this).remove();

        if (!$('.cart-notification-item').length) {
          closeCart();
        }
      });

      $.getJSON(root + 'cart.js').done(updateCartTotals);
    }

    /* -------------------------
       QTY UPDATE QUEUE
       Coalesce rapid +/- clicks so only one cart/change.js runs at a time,
       always with the latest desired quantity. Concurrent requests were
       failing and incorrectly surfacing as "no stock" errors.
    ------------------------- */

    const qtyQueue = {
      inFlight: false,
      pending: new Map()
    };

    function enqueueQtyChange($input) {
      const $item = $input.closest('.cart-notification-item');
      const line = String($item.attr('data-line'));

      if (!line || line === 'removed') return;

      const newQty = parseInt($input.val(), 10) || 0;

      qtyQueue.pending.set(line, { qty: newQty, $input: $input });
      processQtyQueue();
    }

    function processQtyQueue() {
      if (qtyQueue.inFlight) return;

      const next = qtyQueue.pending.entries().next();
      if (next.done) return;

      const [line, { qty, $input }] = next.value;
      qtyQueue.pending.delete(line);
      qtyQueue.inFlight = true;

      $.post(root + 'cart/change.js', { line: line, quantity: qty }, null, 'json')
        .done(function (cart) {
          $input.attr('data-qty', qty);
          updateCartTotals(cart);

          // Rapid clicks may have advanced the input past this response;
          // keep showing the pending target until it flushes.
          const pending = qtyQueue.pending.get(line);
          if (pending) {
            pending.$input.val(pending.qty);
          }
        })
        .fail(function (xhr) {
          qtyQueue.pending.delete(line);

          const msg =
            xhr?.responseJSON?.description ||
            xhr?.responseJSON?.message ||
            stockUnavailableMsg;

          alert(msg);

          // Shopify may still clamp the line to max available stock on error —
          // sync from the real cart instead of trusting the previous local qty.
          $.getJSON(root + 'cart.js')
            .done(function (cart) {
              updateCartTotals(cart);
            })
            .fail(function () {
              $input.val($input.attr('data-qty'));
            });
        })
        .always(function () {
          qtyQueue.inFlight = false;
          processQtyQueue();
        });
    }

    function getInputMax($input) {
      const maxAttr = $input.attr('max');
      if (maxAttr === undefined || maxAttr === null || maxAttr === '') return null;
      const max = parseInt(maxAttr, 10);
      return isNaN(max) ? null : max;
    }

    /* -------------------------
       EVENTS (ITEMS)
    ------------------------- */

    function bindCartEvents() {
      const $items = $('.cart-notification-item');

      /* REMOVE */
      $items.find('.btn-remove').off('click').on('click', function () {
        removeFromCart($(this).closest('.cart-notification-item'));
      });

      /* PLUS */
      $items.find('.plus').off('click').on('click', function () {
        const $input = $(this).siblings('input[type=number]');
        const current = parseInt($input.val(), 10) || 0;
        const max = getInputMax($input);

        if (max !== null && current >= max) {
          alert(stockUnavailableMsg);
          return;
        }

        if ($input[0]) $input[0].stepUp();
        $input.trigger('change');
      });

      /* MINUS */
      $items.find('.minus').off('click').on('click', function () {
        const $input = $(this).siblings('input[type=number]');
        if ($input[0]) $input[0].stepDown();
        $input.trigger('change');
      });

      /* CHANGE QTY */
      $items
        .find('.cart-notification-item__quantity')
        .off('change')
        .on('change', function () {
          const $input = $(this);
          const newQty = parseInt($input.val(), 10) || 0;
          const max = getInputMax($input);

          if (max !== null && newQty > max) {
            alert(stockUnavailableMsg);
            $input.val(Math.min(max, parseInt($input.attr('data-qty'), 10) || max));
            return;
          }

          enqueueQtyChange($input);
        });
    }

    /* -------------------------
       TOTALS
    ------------------------- */

    function updateCartPageState(cart) {
      const $sectionCart = $('.section-cart');
      if (!$sectionCart.length) return;

      const isEmpty = cart
        ? cart.item_count === 0
        : !$sectionCart.find('.cart-notification-item').length;

      if (isEmpty) {
        $sectionCart.addClass('cart-empty');
        $sectionCart.find('.cart__grid, .cart__checkout').attr('hidden', true);
        $sectionCart.find('.cart--content > .cart-empty').removeAttr('hidden');
      } else {
        $sectionCart.removeClass('cart-empty');
        $sectionCart.find('.cart__grid, .cart__checkout').removeAttr('hidden');
        $sectionCart.find('.cart--content > .cart-empty').attr('hidden', true);
      }
    }

    function updateCartTotals(cart) {
      if (cart && cart.items) {
        if (cart.item_count === 0) {
          $('.section-cart .cart-notification-item').remove();
          $('.cart-notification__totals .cart-notification__price').html(formatMoney(0));
          $('.cart__notification__totals .totals-item.subtotal .cart-notification__price').html(
            formatMoney(0)
          );
          $('.cart__notification__totals .totals-item.tax .value').html(formatMoney(0));
          $('.cart__notification__totals .totals-item.total .cart-notification__price').html(
            formatMoney(0)
          );
          $('.num-cart').html(0);
          updateCartPageState(cart);
          return;
        }

        let totalQty = 0;

        cart.items.forEach(function (item, index) {
          const line = index + 1;
          const $item = $('.cart-notification-item[data-line="' + line + '"]');

          if (!$item.length || $item.attr('data-line') === 'removed') return;

          totalQty += item.quantity;

          $item
            .find('.cart-notification-item__quantity')
            .val(item.quantity)
            .attr('data-qty', item.quantity);

          $item
            .find('.cart-item__total-price')
            .html(formatMoney(item.final_line_price));
        });

        const totalPrice = formatMoney(cart.total_price);
        const subtotalPrice = formatMoney(cart.items_subtotal_price);
        const taxPrice = formatMoney(cart.total_tax);

        $('.cart-notification__totals .cart-notification__price').html(totalPrice);
        $('.cart__notification__totals .totals-item.subtotal .cart-notification__price').html(
          subtotalPrice
        );
        $('.cart__notification__totals .totals-item.tax .value').html(taxPrice);
        $('.cart__notification__totals .totals-item.total .cart-notification__price').html(
          totalPrice
        );
        $('.num-cart').html(totalQty);
        updateCartPageState(cart);
        return;
      }

      let totalQty = 0;
      let totalAmount = 0;

      $('.cart-notification-item').each(function () {
        const $item = $(this);

        if ($item.attr('data-line') === 'removed') return;

        const qty =
          parseInt(
            $item.find('.cart-notification-item__quantity').val(),
            10
          ) || 1;

        const price =
          parseFloat($item.find('[data-price]').data('price')) || 0;

        const lineTotal = qty * price;

        totalQty += qty;
        totalAmount += lineTotal;

        $item.find('.cart-item__total-price').html(formatMoney(lineTotal));
      });

      const formattedTotal = formatMoney(totalAmount);

      $('.cart-notification__totals .cart-notification__price').html(formattedTotal);
      $('.cart__notification__totals .totals-item.subtotal .cart-notification__price').html(
        formattedTotal
      );
      $('.cart__notification__totals .totals-item.total .cart-notification__price').html(
        formattedTotal
      );
      $('.num-cart').html(totalQty);
      updateCartPageState();
    }

    /* INIT */
    updateCartTotals();
    bindCartEvents();
  }
};

CartNotification.init();